<template>
  <div>
    <div class="pa-2">
      <v-row>
        <v-col cols="12" v-for="(item, i) in inventory.contact" :key="i">
          <h4 style="color: black">{{ item.name }}</h4>
          <v-text-field
            v-model="item.value"
            :placeholder="`Type your ${item.name} account here`"
            hide-details
            dense
            color="green"
            class="rounded-lg"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="pa-2">
      <v-btn
        depressed
        color="#016443"
        dark
        class="mr-2 px-6 rounded-lg"
        @click="updateData"
      >
        <h5>SEND</h5>
      </v-btn>
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["inventory",],
  name: "editContactVendor",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      role: (state) => state.role,
    })
  },
  mounted() {},
  methods: {
    updateData() {
      this.loading = true;
      let body = {
        id: this.inventory.id,
        contact: this.inventory.contact,
      };
      let role = this.role == "TF" ? "tf" : "vendor_user";
      let data = {
        path: `manage/${role}/update`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
